var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrakingEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Braking Events",
    role: "img",
    viewBox: "0 0 100 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Braking Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999,0c19.2204,0,34.8017,15.67,34.8017,35S69.2204,70,49.9999,70S15.1983,54.33,15.1983,35 c0,0,0,0,0,0C15.2187,15.6786,30.788,0.0205,49.9999,0z M49.9999,63.7866c15.8083,0,28.6235-12.8882,28.6235-28.7866 S65.8083,6.2134,49.9999,6.2134S21.3764,19.1016,21.3764,35C21.3935,50.8913,34.1987,63.7695,49.9999,63.7866z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9134,44.7612c-1.7061,0-3.0891-1.3909-3.0891-3.1067V20.1189c0-1.7158,1.383-3.1067,3.0891-3.1067 c1.7061,0,3.0891,1.3909,3.0891,3.1067v21.5356C53.0025,43.3703,51.6195,44.7612,49.9134,44.7612z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7157,56.933c-1.2553,0.0004-2.3859-0.7634-2.8605-1.9322C1.3011,48.7416-0.0086,42.0393,0,35.2734 c-0.0092-6.7181,1.2813-13.3745,3.7996-19.597c0.6422-1.5882,2.4422-2.3528,4.022-1.7088c1.579,0.6458,2.3393,2.4563,1.699,4.0449 C7.3046,23.4917,6.1694,29.352,6.1782,35.267C6.1663,41.2335,7.3186,47.1442,9.57,52.6644 c0.6459,1.5871-0.1091,3.4002-1.6866,4.051C7.5118,56.8632,7.1153,56.9372,6.7157,56.933z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2842,56.933c-0.4004,0.0004-0.7969-0.0777-1.1676-0.2298c-1.5775-0.6508-2.3325-2.4639-1.6866-4.051 c2.2514-5.5201,3.4038-11.4309,3.3918-17.3974c0.0089-5.9149-1.1264-11.7752-3.3424-17.2544 c-0.6404-1.5886,0.1199-3.3991,1.699-4.0449c1.5798-0.6439,3.3798,0.1206,4.022,1.7088c2.5182,6.2229,3.8087,12.8788,3.7996,19.597 c0.0088,6.7659-1.3009,13.4682-3.8551,19.7274C95.674,56.1624,94.5425,56.9315,93.2842,56.933z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakingEvents);
export default __webpack_public_path__ + "static/media/braking-events.d4857b1aa71afd8e64574a2e919975b0.svg";
export { ForwardRef as ReactComponent };